import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

import "./FilterActionButtons.scss";

const FilterActionButtons = ({
	onClearAll,
	onSelectAll,
	clearAllText,
	selectAllText,
	hasSelections,
	allSelected,
	className
}) => (
	<div className={classnames("filter-action-buttons", className)}>
		<button
			type="button"
			className={classnames("filter-action-btn", { "is-inactive": !hasSelections })}
			onClick={onClearAll}
		>
			<span className="action-text">{clearAllText}</span>
		</button>
		<button
			type="button"
			className={classnames("filter-action-btn", { "is-inactive": allSelected })}
			onClick={onSelectAll}
		>
			<span className="action-text">{selectAllText}</span>
		</button>
	</div>
);

FilterActionButtons.propTypes = {
	onClearAll: PropTypes.func.isRequired,
	onSelectAll: PropTypes.func.isRequired,
	clearAllText: PropTypes.string,
	selectAllText: PropTypes.string,
	hasSelections: PropTypes.bool,
	allSelected: PropTypes.bool,
	className: PropTypes.string
};

FilterActionButtons.defaultProps = {
	clearAllText: "Clear All",
	selectAllText: "Select All",
	hasSelections: false,
	allSelected: false,
	className: ""
};

export default FilterActionButtons;
